export const addFaviconInDOM = (faviconUrl: string) => {
  if (faviconUrl) {
    document.head.insertAdjacentHTML(
      "beforeend",
      `<link rel="icon" href=${faviconUrl} />`,
    );
    document.head.insertAdjacentHTML(
      "beforeend",
      `<link rel="apple-touch-icon" href=${faviconUrl} />`,
    );
  }
};

export const addTitleInDom = (title: string) => {
  if (title) document.title = `${title} - Candidate Interface`;
};
